import {EventEmitter, Injectable} from "@angular/core";
import {HubConnection, HubConnectionBuilder, LogLevel} from "@microsoft/signalr";
import {Store} from "@ngrx/store";
import {
  scanDocumentUsingWebServiceError,
  scanDocumentUsingWebServiceSuccess,
  scanningDocument
} from "../+state/shared.actions";
import {DocScanWebServiceResult, DocumentScanningStatus} from "../models/document-scanning.models";
import {SharedConfigService} from "./shared-config.service";
import {ActivatedRoute} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class DocumentScanningSignalRService {
  private _hubConnection: HubConnection;
  signalRConnected = new EventEmitter<boolean>();
  private webSocketUri: string;

  constructor(
    private store: Store,
    private configService: SharedConfigService,
    private route: ActivatedRoute
  ) {

    this.route.queryParams.subscribe(params => {
      if (params['uid']) {
        sessionStorage.setItem('uid', params['uid']);
      }
    });

    this.configService.getConfig().then((config) => {
      this.webSocketUri = config.webSocketUri;
      this.createConnection();
      this.registerOnServerEvents();
      this.startConnection();
    });

  }

  private createConnection() {

    const uid = sessionStorage.getItem('uid');

    this._hubConnection = new HubConnectionBuilder()
      .withUrl(`${this.webSocketUri}/doc-scanning?uid=${uid}`)
      .configureLogging(LogLevel.Debug)
      .withAutomaticReconnect()
      .build();

    this._hubConnection.onclose((error) => {
      console.log('connection closed');
      console.error(error);
      this.signalRConnected.emit(false);
    });
  }

  private startConnection() {
    this._hubConnection.start()
      .then(() => {
        this.signalRConnected.emit(true);
      })
      .catch((error) => {
        console.error('Error while establishing signalr connection, retrying...', error);
      });
  }

  private registerOnServerEvents() {
    this._hubConnection.on('scanning-update', (status: DocumentScanningStatus) => {
      this.store.dispatch(scanningDocument({status}));
    });

    this._hubConnection.on('scanning-completed-successfully', (data: DocScanWebServiceResult[]) => {
      this.store.dispatch(scanDocumentUsingWebServiceSuccess({data}));
    });

    this._hubConnection.on('scanning-failed', (errors: string[]) => {
      this.store.dispatch(scanDocumentUsingWebServiceError({errors}));
    });
  }

  async updateScanningProcess(status: DocumentScanningStatus) {
    const uid = sessionStorage.getItem('uid');

    await this._hubConnection
      .invoke('UpdateScanningProcess', status, uid)
      .catch(error => console.log(error))
  }
}
